import { InlineText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { LinkButton } from '../../../../../common/LinkButton';
import { ErrorWrapper } from '../ErrorWrapper';

interface IPriceAndGeoEmptyErrorProps {
  onAddButtonClick(): void;
}

export const PriceAndGeoEmptyError = ({ onAddButtonClick }: IPriceAndGeoEmptyErrorProps) => {
  return (
    <ErrorWrapper>
      <InlineText2 textAlign="center">
        Добавьте адрес и цену, чтобы <br /> увидеть конкуренцию
      </InlineText2>

      <LinkButton marginTop={8} onClick={onAddButtonClick}>
        Добавить
      </LinkButton>
    </ErrorWrapper>
  );
};
